module.exports = __webpack_public_path__ + "img/home_douji.4fd6657e.png";